// extracted by mini-css-extract-plugin
module.exports = {"free":"ContactPhoto_free__CQGEj","busy":"ContactPhoto_busy__1tsDM","photo":"ContactPhoto_photo__2fz7L","icon":"ContactPhoto_icon__bJMAm","error":"ContactPhoto_error__3rDoS"};